import { render, staticRenderFns } from "./shop-price.vue?vue&type=template&id=f9126212&scoped=true&"
import script from "./shop-price.vue?vue&type=script&lang=js&"
export * from "./shop-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9126212",
  null
  
)

export default component.exports